export default __webpack_public_path__ + "static/media/testimonial-five-bg.49f4fae4.jpg";